export enum StorageKeys {
  CartState = '__cart_state',
  WishlistState = '__wishlist-state',
  EventsState = '__events-state',
}
